// src/App.js
import React, { useEffect, useMemo } from "react";
import CentroInfoAdminDashboard from "./components/CentroInfoAdminDashboard";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "./authConfig";

/*
  AUTENTICAÇÃO MSAL + WHITELIST POR OID (Object ID)
  -> Substitua os valores em ALLOWED_OIDS pelos Object IDs reais dos
     utilizadores: bernardof, elsal, leonardos.
  -> Para obter OIDs: no Azure Portal (Azure AD → Users → user → Object ID)
*/

const ALLOWED_OIDS = [
  "043daff4-60dc-4917-ad2f-20e94cd83c69", // oid do bernardof
  "fd180db2-3f00-48ee-a5c9-e54dac26bf78", // oid da elsal
  "172f489b-c52a-4a96-b671-44a56ac1e676", // oid do leonardos
];

function App() {
  const { instance, accounts, inProgress } = useMsal();

  const activeAccount = useMemo(() => {
    if (accounts && accounts.length > 0) {
      return accounts[0];
    }
    return instance.getActiveAccount();
  }, [accounts, instance]);

  useEffect(() => {
    if (!activeAccount && accounts && accounts.length > 0) {
      instance.setActiveAccount(accounts[0]);
    }
  }, [activeAccount, accounts, instance]);

  const signIn = () => {
    instance.loginRedirect(loginRequest).catch((e) => {
      console.error("Login redirect failed:", e);
    });
  };

  const signOut = () => {
    instance.logoutRedirect().catch((e) => {
      console.error("Logout redirect failed:", e);
    });
  };

  // show a loading state while MSAL is in progress
  if (inProgress && inProgress !== "none") {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <p>A verificar sessão...</p>
      </div>
    );
  }

  // not authenticated -> show login button
  if (!activeAccount) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16 }}>
        <h1>Centro de Informática</h1>
        <p>Acede com a tua conta institucional (@uatlantica.pt).</p>
        <button
          onClick={signIn}
          style={{
            padding: "10px 20px",
            borderRadius: 999,
            border: "none",
            background: "#4f46e5",
            color: "#fff",
            cursor: "pointer",
            fontSize: 14,
          }}
        >
          Entrar com Azure AD
        </button>
      </div>
    );
  }

  // Get the oid from idTokenClaims (most reliable)
  const oid = activeAccount?.idTokenClaims?.oid || null;

  // Debug: mostra os claims (remove depois)
  console.debug("MSAL activeAccount:", activeAccount);
  console.debug("idTokenClaims:", activeAccount?.idTokenClaims);
  console.debug("Detected oid:", oid);

  const isAllowed = oid && ALLOWED_OIDS.map(x => x.toLowerCase()).includes(oid.toLowerCase());

  // authenticated but not allowed
  if (!isAllowed) {
    const email = activeAccount?.username || activeAccount?.idTokenClaims?.preferred_username || "(sem email)";
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16 }}>
        <h1>Acesso negado</h1>
        <p>
          A conta <strong>{email}</strong> não está autorizada a aceder ao painel.
        </p>
        <button
          onClick={signOut}
          style={{
            padding: "8px 16px",
            borderRadius: 8,
            border: "1px solid #64748b",
            background: "#fff",
            cursor: "pointer",
          }}
        >
          Terminar sessão
        </button>
      </div>
    );
  }

  // authenticated and allowed -> show dashboard
  const user = {
    name: activeAccount?.name || activeAccount?.idTokenClaims?.name || activeAccount?.username,
    email: activeAccount?.username || activeAccount?.idTokenClaims?.preferred_username,
  };

  return <CentroInfoAdminDashboard user={user} onLogout={signOut} />;
}

export default App;
